<template>
  <div class="tac">
    <img
      v-lazy="require('../assets/img/test/no_test.png')"
      style="height: 104px; width: 70px"
    />
    <p class="ft16 bold">这里暂时什么都没有</p>
    <p class="f14 mt-10" style="color: #42686e" @click="goHome">
      先去主页逛逛吧 >
    </p>
  </div>
</template>
<script>
export default {
  name: "NoPic",
  data() {
    return {};
  },
  methods: {
    // 进入主页
    goHome() {
      this.$router.push("/index");
    },
  },
};
</script>
<style lang="less" scoped>
.bold {
  font-weight: bold;
}
</style>